import type { ElementType, ReactNode } from "react";

import styles from "./Text.module.css";

export type TextVariant =
  | "display-l"
  | "display-kpi"
  | "h1"
  | "h2"
  | "h3"
  | "body1"
  | "body2"
  | "body3"
  | "caption"
  | "overline"
  | "toggle"
  | "field"
  | "button"
  | "mono-code";

export type TextColor = "hi" | "default" | "mute" | "disabled" | "on-primary";

export interface Props {
  variant: TextVariant;
  color?: TextColor;
  as?: ElementType;
  className?: string;
  children: ReactNode;
}

const VARIANT_CLASS: Record<TextVariant, string> = {
  "display-l": styles.displayL,
  "display-kpi": styles.displayKpi,
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  body1: styles.body1,
  body2: styles.body2,
  body3: styles.body3,
  caption: styles.caption,
  overline: styles.overline,
  toggle: styles.toggle,
  field: styles.field,
  button: styles.button,
  "mono-code": styles.monoCode,
};

const COLOR_CLASS: Record<TextColor, string> = {
  hi: styles.colorHi,
  default: styles.colorDefault,
  mute: styles.colorMute,
  disabled: styles.colorDisabled,
  "on-primary": styles.colorOnPrimary,
};

export const Text = ({
  variant,
  color = "hi",
  as: Component = "span",
  className,
  children,
}: Props) => {
  const classNames = [VARIANT_CLASS[variant], COLOR_CLASS[color], className]
    .filter(Boolean)
    .join(" ");
  return <Component className={classNames}>{children}</Component>;
};
